
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const SellerSection = () => {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>();

  return (
    <section ref={ref} className="py-20 px-4">
      <div className="container mx-auto text-center max-w-3xl">
        <div className={`bg-gradient-to-r from-[#0052cc]/20 to-[#ffd700]/20 p-8 md:p-12 rounded-lg transition-all duration-700 ${isVisible ? 'animate-scale-in' : 'opacity-0 scale-95'}`}>
          <h2 className="text-4xl font-bold mb-6">
            Have Properties to Sell?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Connect with qualified investors actively looking for deals. List your 
            properties and reach buyers faster with GoDyspo's seller platform. Start with a 30-day free trial.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/seller">
              <Button size="lg" className="bg-[#ffd700] text-[#080c14] hover:bg-[#e6c200] px-8 hover-lift group">
                Learn About Selling
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
            <Link to="/seller/register">
              <Button 
                size="lg" 
                variant="outline" 
                className="border-[#ffd700] text-[#ffd700] hover:bg-[#ffd700] hover:text-[#080c14] hover-lift"
              >
                Start Selling Properties
              </Button>
            </Link>
          </div>
          <p className="text-sm text-gray-400 mt-4">
            30-day free trial • Join thousands of wholesalers and agents
          </p>
        </div>
      </div>
    </section>
  );
};

export default SellerSection;
